export default class Debtor {
  setPrincipalIdNumberWithoutVD(value) {
    this.principalIdNumberWithoutVD = value || '';
    return this;
  }

  setIdNumberWithoutVD(value) {
    if (!value) throw new Error('debtor idNumber is required');
    this.idNumberWithoutVD = value || '';
    return this;
  }

  setIdNumberVD(value) {
    if (!value) throw new Error('debtor idNumber is required');
    this.idNumberVD = value || '';
    return this;
  }

  setFathersLastName(value) {
    this.fathersLastName = value || '';
    return this;
  }

  setMothersLastName(value) {
    this.mothersLastName = value || '';
    return this;
  }

  setIncomesCurrency(value) {
    this.incomesCurrency = value || '';
    return this;
  }

  setName(value) {
    if (!value) throw new Error('debtor name is required');
    this.name = value || '';
    return this;
  }

  setBirthdate(value) {
    this.birthdate = value || '';
    return this;
  }

  setActivityCode(value) {
    this.activityCode = value || '';
    return this;
  }

  setBankAccountNumber(value) {
    this.bankAccountNumber = value || '';
    return this;
  }

  setIsDependent(value) {
    this.isDependent = value || '';
    return this;
  }

  setPropertySeparationRegime(value) {
    this.propertySeparationRegime = value || '';
    return this;
  }

  setNumberOfLiabilities(value) {
    this.numberOfLiabilities = value || '';
    return this;
  }

  setAddress(value) {
    this.address = value || '';
    return this;
  }

  setPostalCode(value) {
    this.postalCode = value || '';
    return this;
  }

  setParticularPhoneNumber(value) {
    if (!value) throw new Error('debtor particular phone number is required');
    this.particularPhoneNumber = value || '';
    return this;
  }

  setCommercialPhoneNumber(value) {
    this.commercialPhoneNumber = value || '';
    return this;
  }

  setCommercialAnnex(value) {
    this.commercialAnnex = value || '';
    return this;
  }

  setCommercialFax(value) {
    this.commercialFax = value || '';
    return this;
  }

  setFinancialDebt(value) {
    this.finantialDebt = value || '';
    return this;
  }

  setFinancialDefaultingDebt(value) {
    this.financialDefaultingDebt = value || '';
    return this;
  }

  setOverdueFinancialDebt(value) {
    this.overdueFinancialDebt = value || '';
    return this;
  }

  setNumberOfProtests(value) {
    this.numberOfProtests = value || '';
    return this;
  }

  setCommercialDebt(value) {
    this.commercialDebt = value || '';
    return this;
  }

  setLastEmploymentEntranceDate(value) {
    this.lastEmploymentEntranceDate = value || '';
    return this;
  }

  setCellphoneNumber(value) {
    this.cellphoneNumber = value || '';
    return this;
  }

  setJobTitle(value) {
    this.jobTitle = value || '';
    return this;
  }

  setMonthlyIncome(value) {
    this.monthlyIncome = value || '';
    return this;
  }

  setEmployerIdNumber(value) {
    this.employerIdNumber = value || '';
    return this;
  }

  setEmployerName(value) {
    this.employerName = value || '';
    return this;
  }

  setEmployerAddress(value) {
    this.employerAddress = value || '';
    return this;
  }

  setEmployerPhoneNumber(value) {
    this.employerPhoneNumber = value || '';
    return this;
  }

  setEmployerAnnex(value) {
    this.employerAnnex = value || '';
    return this;
  }

  setClearedUpProtests(value) {
    this.clearedUpProtests = value || '';
    return this;
  }

  setNonCLearedUpProtests(value) {
    this.nonClearedUpProtests = value || '';
    return this;
  }

  setSicomDefaulting(value) {
    this.sicomDefaulting = value || '';
    return this;
  }

  setCountry(value) {
    this.country = value || '';
    return this;
  }

  setNationality(value) {
    this.nationality = value || '';
    return this;
  }

  setEmployerCountry(value) {
    this.employerCountry = value || '';
    return this;
  }

  setEducation(value) {
    this.education = value || '';
    return this;
  }

  setSex(value) {
    this.sex = value || '';
    return this;
  }

  setCivilStatus(value) {
    this.civilStatus = value || '';
    return this;
  }

  setInstitution(value) {
    this.institution = value || '';
    return this;
  }

  setEmployerCommune(value) {
    this.employerCommune = value || '';
    return this;
  }

  setEmail(value) {
    if (!value) throw new Error('debtor email is required');
    this.email = value || '';
    return this;
  }

  setDebtorCommune(value) {
    this.debtorCommune = value || '';
    return this;
  }

  setProfession(value) {
    this.profession = value || '';
    return this;
  }

  setEmploymentStatus(value) {
    this.employmentStatus = value || '';
    return this;
  }

  setValidity(value) {
    this.validity = value || '';
    return this;
  }
}
